"use strict";

var _regeneratorRuntime = require("/home/travis/build/ulabox/boksa/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.resetPassword = exports.logout = exports.login = exports.selectCartID = void 0;

var _object = require("lodash/object");

var _effects = require("redux-saga/effects");

var _router = require("@modules/router");

var _cart = require("@modules/cart");

var _account = require("@modules/account");

var _snackbar = require("@modules/snackbar");

var _actions = require("./actions");

var selectCartID = function selectCartID(state) {
  return state.cart.id;
};

exports.selectCartID = selectCartID;

var login =
/*#__PURE__*/
_regeneratorRuntime.mark(function login(action) {
  var customerToken, cartID;
  return _regeneratorRuntime.wrap(function login$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          customerToken = (0, _object.get)(action, 'customerToken');
          _context.next = 4;
          return (0, _effects.select)(selectCartID);

        case 4:
          cartID = _context.sent;
          _context.next = 7;
          return (0, _effects.put)((0, _actions.setCustomerToken)(customerToken));

        case 7:
          _context.next = 9;
          return (0, _effects.put)(_cart.cartActions.fetchCart(cartID));

        case 9:
          _context.next = 11;
          return (0, _effects.put)(_account.accountActions.fetchAccount(customerToken));

        case 11:
          _context.next = 13;
          return (0, _effects.put)(_account.accountActions.changeLanguage(action.language));

        case 13:
          _context.next = 15;
          return (0, _effects.put)(_router.routerActions.flushTo(action.redirectRoute));

        case 15:
          _context.next = 20;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);

        case 20:
        case "end":
          return _context.stop();
      }
    }
  }, login, this, [[0, 17]]);
});

exports.login = login;

var logout =
/*#__PURE__*/
_regeneratorRuntime.mark(function logout(action) {
  return _regeneratorRuntime.wrap(function logout$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.put)((0, _actions.purgeAll)());

        case 3:
          _context2.next = 5;
          return (0, _effects.put)(_router.routerActions.flushTo(action.redirectRoute));

        case 5:
          _context2.next = 10;
          break;

        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);

        case 10:
        case "end":
          return _context2.stop();
      }
    }
  }, logout, this, [[0, 7]]);
});

exports.logout = logout;

var resetPassword =
/*#__PURE__*/
_regeneratorRuntime.mark(function resetPassword(action) {
  return _regeneratorRuntime.wrap(function resetPassword$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.put)(_router.routerActions.navigateTo(action.redirectRoute));

        case 3:
          _context3.next = 5;
          return (0, _effects.put)(_snackbar.snackbarActions.show({
            action: 'OK',
            message: action.successMessage
          }));

        case 5:
          _context3.next = 10;
          break;

        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](0);
          console.error(_context3.t0);

        case 10:
        case "end":
          return _context3.stop();
      }
    }
  }, resetPassword, this, [[0, 7]]);
});

exports.resetPassword = resetPassword;

var auth =
/*#__PURE__*/
_regeneratorRuntime.mark(function auth() {
  return _regeneratorRuntime.wrap(function auth$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)(_actions.FETCH_LOGIN_SUCCESS, login);

        case 2:
          _context4.next = 4;
          return (0, _effects.takeLatest)(_actions.LOGOUT, logout);

        case 4:
          _context4.next = 6;
          return (0, _effects.takeLatest)(_actions.FETCH_RESET_PASSWORD_SUCCESS, resetPassword);

        case 6:
        case "end":
          return _context4.stop();
      }
    }
  }, auth, this);
});

var _default = auth;
exports.default = _default;